<ng-container *ngIf="lineItems.length > 0; else loading">
  <div class="simple-card" style="padding: 12px 0">
    <table class="table-responsive table-md">
      <section id="section-responsive-account-table m-t-20" class="container">
        <table class="table-responsive table-md" style="border-radius: 0">
          <thead>
            <th>{{ 'quotes.history.tableHeader.lineNumber' | cxTranslate }}</th>
            <th>{{ 'quotes.history.tableHeader.partNumber' | cxTranslate }}</th>
            <th>{{ 'quotes.history.tableHeader.catalogNumber' | cxTranslate }}</th>
            <th>{{ 'quotes.history.tableHeader.customerPartNumber' | cxTranslate }}</th>
            <th>{{ 'quotes.history.tableHeader.qty' | cxTranslate }}</th>
            <th>{{ 'quotes.history.tableHeader.uom' | cxTranslate }}</th>
            <th>{{ 'quotes.history.tableHeader.sellingPrice' | cxTranslate }}</th>
            <th></th>
          </thead>
          <tbody>
            <tr *ngFor="let line of lineItems">
              <td>
                <span class="responsive-title"> {{ 'quotes.history.tableHeader.lineNumber' | cxTranslate }}: </span>
                {{ line.lineNumber }}
              </td>
              <td>
                <span class="responsive-title"> {{ 'quotes.history.tableHeader.partNumber' | cxTranslate }}: </span>
                @if (!line.isCustom) {
                  <button class="btn-link" (click)="navigate(line.partNumber)">
                    {{ line.partNumber }}
                  </button>
                } @else {
                  {{ line.partNumber }}
                }
              </td>
              <td>
                <span class="responsive-title"> {{ 'quotes.history.tableHeader.catalogNumber' | cxTranslate }}: </span>
                {{ line.catalogNumber }}
              </td>
              <td>
                <span class="responsive-title"> {{ 'quotes.history.tableHeader.customerPartNumber' | cxTranslate }}: </span>
                {{ line.customerPartNumber }}
              </td>
              <td>
                <span class="responsive-title"> {{ 'quotes.history.tableHeader.qty' | cxTranslate }}: </span>
                {{ line.quantityQuoted }}
              </td>
              <td>
                <span class="responsive-title"> {{ 'quotes.history.tableHeader.uom' | cxTranslate }}: </span>
                {{ line.uom }}
              </td>
              <td>
                <span class="responsive-title"> {{ 'quotes.history.tableHeader.sellingPrice' | cxTranslate }}: </span>
                {{ line.sellingPrice.formattedValue }}
              </td>
              <td>
                @if (line.enableAddToCart) {
                  <button class="btn-link" (click)="addToCart(line.uid, line.partNumber, line.quantityQuoted)">
                    {{ 'quotes.history.addToCart' | cxTranslate }}
                  </button>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </table>
  </div>
</ng-container>

<ng-template #loading>
  <p>Loading quotes...</p>
</ng-template>
